import "@/App.css";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { TrustBar } from "@/components/site/TrustBar";
import { Services } from "@/components/site/Services";
import { RecentWork } from "@/components/site/RecentWork";
import { Veteran } from "@/components/site/Veteran";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  return (
    <div className="App grain relative bg-[#09090b] min-h-screen">
      <Toaster position="top-center" theme="dark" richColors />
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Services />
        <RecentWork />
        <Veteran />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
